import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { parseQuery } from "../utils/UrlUtils";

export function useQuery<T = any>(): T {
  const location = useLocation();

  return useMemo(() => parseQuery(location.search), [location.search]) as any;
}
